import {applyImageLightbox} from '../../modules/imageLightbox.js';
import '../../behaviors/reportButtons.js';

/**
 * Init page, register event handlers
 */
function initPage() {
    // Make all images in content have lightbox feature, but images in the any widget
    applyImageLightbox(
        document.querySelectorAll('.js-jobPostingsContent img:not(.rteContent__isolatedBlock)'));

    // Delegate clicks on the "Save This Job" wrapper to the bookmark button inside it
    const bookmarkWrapper = document.querySelector('[data-bookmark-wrapper]');
    if (bookmarkWrapper) {
        bookmarkWrapper.addEventListener('click', (event) => {
            if (!event.target.closest('.js-bookmarkButton')) {
                bookmarkWrapper.querySelector('.js-bookmarkButton')?.click();
            }
        });
    }
}

// Initialize when DOM is ready
document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initPage)
    : initPage();
